import React from 'react';
import ReactModal from 'react-modal';
import SVGClose from '../../svg/Close';

// config
ReactModal.setAppElement('#root'); // for hiding aria

// wraps react-modal with set defaults
class Modal extends React.Component {
  render() {
    const { props } = this;
    if (!props.isOpen) return null;

    return (
      <ReactModal {...props}>
        <span className="modal__close-btn" onClick={props.onRequestClose}>
          <SVGClose />
        </span>
        {props.children}
      </ReactModal>
    );
  }

  static defaultProps = {
    shouldCloseOnOverlayClick: true,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldReturnFocusAfterClose: true,
    overlayClassName: 'modal__overlay',
    className: 'modal modal--padded',
    bodyOpenClassName: 'modal--open'
  };
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/Modal.js